import * as types from './types'

export default {
  [types.RESET_CHANNELS](state) {
    state.channels = []
    state.mychannels = []
    state.requests = []
    state.firmCounts = []
  },
  [types.RESET_CHANNELINFO](state) {
    state.channelInfo = null
    state.messages = []
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.SET_HANDLER](state, id) {
    state.handlerId = id
  },
  [types.SET_CHANGED](state, data) {
    state.changed = data
  },
  [types.SET_TYPING](state, data) {
    state.someoneTyping = data
  },
  [types.RESET_FOUND_MEMBERS](state) {
    state.foundMembers = []
  },
  [types.SET_USER](state, user) {
    state.user = user
  },
  async [types.QUIT_CHAT](state, data) {
    state.groupChannelHandler = null
    state.handlerId = null
    window.sendbird = null
  },
  [types.SET_A_MYCHANNEL](state, data) {
    state.mychannels.push(data)
  },
  [types.SET_A_CHANNEL](state, data) {
    state.channels.push(data)
  },
  [types.SET_A_REQUEST](state, data) {
    state.requests.push(data)
  },
  [types.SET_A_MESSAGE](state, message) {
    state.messages.push(message)
  },
  [types.ADD_MEMBERS](state, members) {
    state.channelInfo.members = state.channelInfo.members.concat(members)
  },
  [types.SET_CHATBAR](state, data) {
    if (data) {
      switch (data.name) {
        case 'add':
          // add to the chat bar
          if (state.channelInfo) {
            let there = null
            if (state.chatBar) {
              if (state.chatBar.length > 0) {
                there = state.chatBar.find(x => x.url === state.channelInfo.url)
              }
            }
            if (!there) {
              state.chatBar.push({
                url: state.channelInfo.url,
                metadata: state.channelInfo.metadata,
                name: state.channelInfo.name,
                type: state.channelInfo.type.substring(0, 7) === 'request' ? 'request' : 'adhoc',
                unreadCount: state.channelInfo.unreadCount
              })
            }
          }
          break
        case 'remove':
          // remove from the chat bar
          state.chatBar = state.chatBar.filter(x => x.url !== data.value)
          break
        case 'show':
          break
      }
      console.log('Set Chat Bar', state.chatBar)
    }
  },
  [types.SET_FIRMCOUNTS](state) {
    let myChatCount = 0
    state.mychannels.forEach(element => {
      myChatCount += element.unreadCount
    })
    state.firmCounts = [
      {
        firm: 0,
        name: 'My Sessions',
        unreadCount: myChatCount
      },
      {
        firm: -1,
        name: 'Active Requests',
        unreadCount: 0
      }
    ]
    // set up the firms in firmCounts
    state.channels.forEach(element => {
      if (element.metadata) {
        let found = state.firmCounts.find(x => parseInt(x.firm) === parseInt(element.metadata.firm))
        if (found === undefined || found === null) {
          state.firmCounts.push({
            firm: parseInt(element.metadata.firm),
            name: element.metadata.firmName,
            unreadCount: element.unreadCount
          })
        }
      }
    })
    console.log('Got Firm Counts', state.firmCounts)
  },
  [types.GET_UNREAD](state, counts) {
    try {
      state.unreadCount = counts
      if (state.chatBar.length > 0) {
        // if the chatBar has any channels, update the counts
        console.log('Update Chat Bar counts', {
          mychannels: state.mychannels,
          channels: state.channels
        })
        state.chatBar.forEach(tab => {
          let found = state.mychannels.find(x => x.url === tab.url)
          if (found) {
            tab.unreadCount = found.unreadCount
          } else {
            found = state.channels.find(x => x.url === tab.url)
            if (found) {
              tab.unreadCount = found.unreadCount
            }
          }
        })
      }
    } catch (e) {
      console.log('Error (GET_UNREAD)', e)
    }
  },
  [types.SET_CHANNELINFO](state, data) {
    state.channelInfo = data
  },
  [types.UPDATE_CHANNELINFO](state, data) {
    state.channelInfo.createdOn = data.createdOn
    state.channelInfo.type = data.type
    state.channelInfo.members.push(data.member)
    state.channelInfo.memberCount = state.channelInfo.members.length
  },
  [types.JOIN_CHANNEL](state, url) {
    let found = state.channels.find(x => x.url === url)
    if (found) {
      found.join()
    }
  },
  [types.LEAVE_CHANNEL](state, url) {
    let found = state.channels.find(x => x.url === url)
    if (found) {
      found.leave()
    }
  },
  [types.SET_FOUND_MEMBER](state, member) {
    state.foundMembers.push(member)
  },
  [types.SET_FOUND_MEMBERS](state, data) {
    state.foundMembers = []
    if (data) {
      if (Array.isArray(data)) {
        state.foundMembers = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js